<template>
    <div style="height: 100%">
        <sa-tabs-scroll-component idTab="tabsStoricoStati" classNavItem="nav-item" />

        <b-tabs id="tabsStoricoStati" ref="tabsStoricoStati" v-model="activeTabIndex" nav-wrapper-class="sa-tab-items" content-class="mt-3" class="sa-tab" fill @input="onInputTabs">
            <b-tab title="ACCETTAZIONE">
                <rsa-paziente-storico-stati-accettazione-list-component ref="cmpRsaPazienteStoricoStatiAccettazioneListComponent" />
            </b-tab>

            <b-tab title="SETTING"> <rsa-paziente-storico-stati-setting-list-component ref="cmpRsaPazienteStoricoStatiSettingListComponent" /> </b-tab>

            <b-tab title="CONSENSI"> <rsa-paziente-storico-stati-consensi-list-component ref="cmpRsaPazienteStoricoStatiConsensiListComponent" /> </b-tab>

            <b-tab title="RICHIESTE LABORATORIO"> <rsa-paziente-storico-stati-richieste-laboratorio-list-component ref="cmpRsaPazienteStoricoStatiRichiesteLaboratorioListComponent" /> </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import PermessiMixin from "../../../utility/PermessiMixin";
import SaTabsScrollComponent from "../../../../template/components/utility/SaTabsScrollComponent.vue";
import RsaPazienteStoricoStatiAccettazioneListComponent from "./RsaPazienteStoricoStatiAccettazioneListComponent.vue";
import RsaPazienteStoricoStatiSettingListComponent from "./RsaPazienteStoricoStatiSettingListComponent.vue";
import RsaPazienteStoricoStatiConsensiListComponent from "./RsaPazienteStoricoStatiConsensiListComponent.vue";
import RsaPazienteStoricoStatiRichiesteLaboratorioListComponent from "./RsaPazienteStoricoStatiRichiesteLaboratorioListComponent.vue";

export default {
    mixins: [UtilityMixin, PermessiMixin],

    components: {
        SaTabsScrollComponent,
        RsaPazienteStoricoStatiAccettazioneListComponent,
        RsaPazienteStoricoStatiSettingListComponent,
        RsaPazienteStoricoStatiConsensiListComponent,
        RsaPazienteStoricoStatiRichiesteLaboratorioListComponent,
    },

    data() {
        return {
            activeTabIndex: 0,
            activeTabId: "ACCETTAZIONE",
            keyIndex: 0,
            jsonDataAccettazione: {},
            storicoStatiTabs: [
                { id: "ACCETTAZIONE", title: "ACCETTAZIONE" },
                { id: "SETTING", title: "SETTING" },
                { id: "CONSENSI", title: "CONSENSI" },
                { id: "RICHIESTE LABORATORIO", title: "RICHIESTE LABORATORIO" },
            ],
        };
    },

    methods: {
        init(jsonDataAccettazione) {
            this.jsonDataAccettazione = jsonDataAccettazione;
            this.activeTabIndex = 0;
            this.activeTabId = this.storicoStatiTabs[0].id;
            this.loadDataForActiveTab();
        },

        onInputTabs(index) {
            this.activeTabIndex = index;
            this.activeTabId = this.storicoStatiTabs[index]?.id || null;
            this.loadDataForActiveTab();
        },

        loadDataForActiveTab() {
            switch (this.activeTabId) {
                case "ACCETTAZIONE":
                    this.$nextTick(() => {
                        this.$refs.cmpRsaPazienteStoricoStatiAccettazioneListComponent?.loadDataAccettazione?.(this.jsonDataAccettazione);
                    });
                    break;
                case "SETTING":
                    this.$nextTick(() => {
                        this.$refs.cmpRsaPazienteStoricoStatiSettingListComponent?.loadDataAccettazione?.(this.jsonDataAccettazione);
                    });
                    break;
                case "CONSENSI":
                    this.$nextTick(() => {
                        this.$refs.cmpRsaPazienteStoricoStatiConsensiListComponent?.loadDataAccettazione?.(this.jsonDataAccettazione);
                    });
                    break;
                case "RICHIESTE LABORATORIO":
                    this.$nextTick(() => {
                        this.$refs.cmpRsaPazienteStoricoStatiRichiesteLaboratorioListComponent?.loadDataAccettazione?.(this.jsonDataAccettazione);
                    });
                    break;
            }
        },
    },
};
</script>
